/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/fighter_1v3': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="30" cy="30.077" r="2"/><circle pid="1" cx="30" cy="2.077" r="2"/><circle pid="2" cx="2" cy="2.077" r="2"/><path pid="3" d="M13 16.077h6l-3-7z"/><g><path pid="4" d="M16 20.077a.5.5 0 01-.5-.5v-1.5a.5.5 0 011 0v1.5a.5.5 0 01-.5.5zM16 23.577a.5.5 0 01-.5-.5v-1.5a.5.5 0 011 0v1.5a.5.5 0 01-.5.5z"/></g><g><path pid="5" d="M3 12.331H2v-4.29l3.72-2.136.498.867L3 8.62zM19.221 3.002L16 1.153l-3.22 1.849-.498-.867L16 0l3.718 2.135zM30 12.331h-1V8.62l-3.218-1.848.497-.867L30 8.041zM26.279 26.25l-.497-.867L29 23.535v-3.71h1v4.289zM16 32.152l-3.718-2.132.498-.87L16 31l3.221-1.85.497.87zM5.72 26.25L2 24.114v-4.289h1v3.71l3.218 1.848z"/></g>'
  }
})
